"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightArrow = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var RightArrow = function (props) { return (react_1.default.createElement("svg", tslib_1.__assign({ width: "23", height: "10", viewBox: "0 0 23 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M0.953125 4.90918H21.9531", stroke: "#757370" }),
    react_1.default.createElement("path", { d: "M17.9531 0.90918L21.9531 4.90918L17.9531 8.90918", stroke: "#757370" }))); };
exports.RightArrow = RightArrow;
//# sourceMappingURL=RightArrow.js.map